import React from "react";
import Icon from "../common/Icon";
import { APP_COPY } from "../../config/appConfig";

export default function AppHeader({
  metadata,
  showColumns,
  onToggleColumns,
  isLoadingMetadata,
  onRefresh,
  isRefreshing,
}) {
  const rowsCount = metadata?.rowsCount || 0;
  const columnCount = metadata?.columns?.length || 0;

  return (
    <header className="app-header">
      <div>
        <h1 className="app-title">{APP_COPY.title}</h1>
        <p className="app-sub">{APP_COPY.subtitle}</p>
        <div className="app-meta-line">
          <Icon name="dataset" size={16} />
          {isLoadingMetadata
            ? "Loading dataset…"
            : `${rowsCount.toLocaleString()} extensions • ${
                APP_COPY.datasetLabel
              }`}
        </div>
      </div>
      <div className="header-actions">
        <button
          className="meta-toggle"
          type="button"
          onClick={onRefresh}
          disabled={isRefreshing}
          title="Refresh dataset"
        >
          <Icon
            name="refresh"
            size={16}
            className={isRefreshing ? "spinning" : ""}
          />
          {isRefreshing ? "Refreshing…" : "Refresh data"}
        </button>
        <button
          className="meta-toggle"
          type="button"
          onClick={onToggleColumns}
          aria-pressed={showColumns}
          title={APP_COPY.datasetTooltip}
        >
          <Icon name="clipboard" size={16} />
          {showColumns
            ? "Hide columns"
            : `Explore dataset columns (${columnCount})`}
        </button>
      </div>
    </header>
  );
}
